import { combineReducers } from "@reduxjs/toolkit";
import { uIReducer } from "./uIReducer";
import { userReducer } from "./userReducer";
import { organizationReducer } from "./organizationReducer";
import { plantReducer } from "./plantReducer";
import { RdxType } from "../Types";

const reducers = combineReducers({
    ui: uIReducer,
    user: userReducer,
    organization: organizationReducer,
    plants: plantReducer
});


export {
    reducers
}